import {
  BookingTolerancesListQuery,
  BrandAndMarketListItem,
  GuidIdAndLabel,
  GuidIdCodeAndLabel,
  Int32IdAndLabel,
} from "../../../integrated-client/models";
import {
  DEFAULT_LIMIT_PAGINATION,
  DEFAULT_OFFSET,
  DEFAULT_TOTAL_ITEMS,
} from "../../../utils/Constants";

export interface IFiltersData extends BookingTolerancesListQuery {
  total: number;
  currentPage: number;
}

export class FiltersData implements IFiltersData {
  brandAndMarket?: BrandAndMarketListItem;
  distributionChannel?: Int32IdAndLabel;
  description?: string | null;
  relevance?: number | null;
  supplier?: GuidIdAndLabel;
  carrier?: GuidIdCodeAndLabel;
  showDisabled?: boolean;
  showDeleted?: boolean;
  offset: number;
  limit: number;
  currentPage: number;
  total: number;
  orderByRelevanceAscending: boolean;

  constructor() {
    this.offset = DEFAULT_OFFSET;
    this.limit = DEFAULT_LIMIT_PAGINATION;
    this.total = DEFAULT_TOTAL_ITEMS;
    this.currentPage = 1;
    this.orderByRelevanceAscending = false;
  }
}
